module.exports = __webpack_public_path__ + "static/media/mech_breakdown_motor.d449d938.svg";